import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'trimName',
    standalone: true
})
export class TrimNamePipe implements PipeTransform {
    transform(name: string, limit: number = 30): string {
        if (!name) return '';
        return name.length > limit ? name.substring(0, limit) + '...' : name;
    }
}

@Pipe({
    name: 'screenIconGetter',
    standalone: true
})
export class ScreenIconGetterPipe implements PipeTransform {
    transform(image: any): string | null {
        if (!image || image._appIconErr) {
            return null;
        }
        const u = image.app_icon_url || image.app_icon || image.application_icon_url;
        return typeof u === 'string' && u.length > 0 ? u : null;
    }
}

@Pipe({ name: 'appIconGlyph', standalone: true })
export class AppIconGlyphPipe implements PipeTransform {
    transform(image: any): string {
        const name = (image?.app_name || '').toLowerCase();
        if (/chrome|edge|firefox|safari|brave|opera/.test(name)) return 'language';
        if (/code|cursor|vscode|visual studio/.test(name)) return 'code';
        if (/slack|teams|discord|zoom|meet/.test(name)) return 'forum';
        if (/figma|sketch|photoshop|illustrator|premiere|adobe/.test(name)) return 'palette';
        if (/excel|word|powerpoint|outlook|office/.test(name)) return 'table_chart';
        if (/terminal|powershell|cmd|iterm|warp/.test(name)) return 'terminal';
        if (/explorer|finder|files?/.test(name)) return 'folder_open';
        return 'widgets';
    }
}

export const SHARED_PIPES = [TrimNamePipe, ScreenIconGetterPipe, AppIconGlyphPipe];